import { IGetInformacoesEntregaObraClienteByIdUseCase } from "../../../presentation/useCases/read/get_informacoes_entrega_obra_cliente_by_id_use_case";
import { InformacoesEntregaObraClienteModel } from "../../models/informacoes_entrega_obra_cliente";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetInformacoesEntregaObraClienteByIdUseCase
 */

export class GetInformacoesEntregaObraClienteByIdUseCase implements IGetInformacoesEntregaObraClienteByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObraCliente: number): Promise<InformacoesEntregaObraClienteModel> {
    return await this.repository.getInformacoesEntregaObrasCliente(idEntregaObraCliente);

  }

}
